export const getIfoodFeedbackReviewState = (feedback = {}) => {
  const integration = feedback.integracao || null;
  const isIfood = String(feedback.origem || '').toLowerCase() === 'ifood'
    && Boolean(integration?.origem_registro_id);
  const status = String(integration?.status || '').toUpperCase();
  const replies = Array.isArray(integration?.respostas) ? integration.respostas : [];
  const merchantReply = [...replies].reverse().find((reply) => (
    String(reply?.from || '').toUpperCase() === 'MERCHANT'
  )) || null;
  return {
    integration,
    isIfood,
    status,
    replies,
    merchantReply,
    canAnswer: isIfood && status === 'NOT_REPLIED',
  };
};
